export default "__VITE_ASSET__BWK5wSdE__"